import _ from 'underscore';

import {NoteLinkedObjectType} from 'notebook/util/NoteUtilConstants';

import {EditorMixinInterface} from '../Editor';
import convertStructuredTableForPaste from '../structured-tables/convertStructuredTableForPaste';

export default function convertMixtureGroupForPaste(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any,
  name: string | null,
  component: Partial<EditorMixinInterface>,
  usedTableNames: Array<string>,
  destinationFileId: string,
  isConfig: boolean | undefined
): void {
  for (let i = 0; i < item.item.containedNoteParts.length; i++) {
    const containedNotePart = item.item.containedNoteParts[i];
    const containedItem = containedNotePart.item;
    if (component.props!.getType(containedItem) === NoteLinkedObjectType.STRUCTURED_TABLE) {
      const newContainedNotePart = convertStructuredTableForPaste(containedNotePart, {
        usedTableNames,
        destinationFileId,
        isDestinationConfig: isConfig,
      }).item;
      if ((newContainedNotePart as unknown as {kind: string}).kind === 'MIXTURE_METADATA') {
        newContainedNotePart.item.name = `${name} mixture`;
      } else if ((newContainedNotePart as unknown as {kind: string}).kind === 'MIXTURE_INGREDIENTS') {
        newContainedNotePart.item.name = `${name} ingredients`;
      }
      newContainedNotePart.cid = _.uniqueId('note-part');
      item.item.containedNoteParts[i] = newContainedNotePart;
    }
  }
}
